module.exports = __webpack_public_path__ + "img/20190723145646396.d09d8c06.png";